import React, { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Header from './header';
import Footer from './footer';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import tv_1 from '../pdfFiles/pdf1.pdf';
import tv_2 from '../pdfFiles/pdf2.pdf';
import hood from '../pdfFiles/pdf3.pdf';
import dishwasher from '../pdfFiles/pdf4.pdf';
import oven from '../pdfFiles/pdf5.pdf';
import mirror from '../pdfFiles/mirror.pdf';
import toilet from '../pdfFiles/toilet.pdf';
import CircleIcon from '@mui/icons-material/Circle';






function BusinessPage() {
    const theme = useTheme();
    const isSmDown = useMediaQuery(theme.breakpoints.down('md'));
    const { t, i18n } = useTranslation();

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
}, []);


    const headerFontSize = isSmDown ? "2rem" : "4rem";
    const leftPadding = isSmDown ? 5 : 20;
    const fontSize1 = isSmDown ? "1.5rem" : "2rem";
    const fontSize2 = isSmDown ? "1.3rem" : "1.8rem";
    const fontSize3 = isSmDown ? "2rem" : "2.5rem";
    const fontSize4 = isSmDown ? "1.2rem" : "1.5rem";
    return (
        <Container disableGutters maxWidth={false} sx={{minHeight: "auto", bgcolor: "grey", maxWidth: "100%"}}>
            <Container disableGutters maxWidth={false} sx={{width: "inherit", backgroundColor:`#DFDFDF`, minHeight: "auto", display: "flex", flexDirection: "column"}}>
            <Header/>
            <Box sx={{width: "90%", fontFamily: "Cormorant Garamond", color: "black", fontSize: headerFontSize, fontWeight: 400, textTransform: "uppercase", pt: 5,  display: "flex", alignItems: "center", justifyContent: 'center', alignSelf:"center", borderBottom: 5, borderColor: "#001524"}}>
                {t("business_offers")}
            </Box>
            <Stack>
                <Box sx={{textAlign: "center", width: "90%", fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize1, fontWeight: 500, pt: 10,  display: "flex", alignItems: "center", justifyContent: 'center', alignSelf:"center", textTransform: "uppercase"}}>
                    {t("business_heading")}
                </Box>
                <Box sx={{textAlign: "center", width: "80%", fontFamily: "Cormorant Garamond", color: "black", fontSize: "2rem", fontWeight: 400, pt: 5,  display: "flex", alignItems: "center", justifyContent: 'center', alignSelf:"center"}}>
                    <Typography>
                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "black", fontSize: fontSize2, fontWeight: 400}}>
                    {t("business_intro1")}
                    </Box>
                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "black", fontSize: fontSize2, fontWeight: 600}}>
                    {t("business_intro2")}
                    </Box>
                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "black", fontSize: fontSize2, fontWeight: 400}}>
                    {t("business_intro3")}
                    </Box>
                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "black", fontSize: fontSize2, fontWeight: 600}}>
                    {t("business_intro4")}
                    </Box>
                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "black", fontSize: fontSize2, fontWeight: 400}}>
                    {t("business_intro5")}
                    </Box>
                    </Typography>
                </Box>
            </Stack>
            <Box sx={{pb: 10, pt: 8, pl: leftPadding, minWidth: "auto"}}>
                        <Stack spacing={0} sx={{width: "80%"}}>
                            <Box sx={{pt: 2}}>
                                <Typography sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize3, fontWeight: 500, textTransform: "uppercase"}}>{t("business_info_1")}</Typography>
                            </Box>
                            <Box sx={{pt: 1, pb: 1, borderTop: 1, borderBottom: 1, borderColor: "#15616D", display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 600}}>
                                {t("business_info_1_details1")}
                                    </Box>{' '}
                                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 500}}>
                                    {t("business_info_1_details1_extra1")}
                                    </Box>
                                </Typography>
                            </Box>

                            <Box sx={{pt: 8}}>
                                <Typography sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize3, fontWeight: 500, textTransform: "uppercase"}}>{t("business_info_2")}</Typography>
                            </Box>
                            <Box sx={{pt: 1, borderTop: 1, borderColor: "#15616D", display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 600}}>
                                {t("business_info_2_details1")}
                                    </Box>{' '}
                                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 500}}>
                                    {t("business_info_2_details1_extra1")}
                                    </Box>
                                </Typography>
                            </Box>
                            <Box sx={{ display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 600}}>
                                {t("business_info_2_details2")}
                                    </Box>{' '}
                                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 500}}>
                                    {t("business_info_2_details1_extra2")}
                                    </Box>
                                </Typography>
                            </Box>
                            <Box sx={{display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 600}}>
                                {t("business_info_2_details3")}
                                    </Box>{' '}
                                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 500}}>
                                    {t("business_info_2_details1_extra3")}
                                    </Box>
                                </Typography>
                            </Box>
                            <Box sx={{display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 600}}>
                                {t("business_info_2_details4")}
                                    </Box>
                                </Typography>
                            </Box>
                            <Box sx={{pb: 1, borderBottom: 1, borderColor: "#15616D", display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 600}}>
                                {t("business_info_2_details5")}
                                    </Box>{' '}
                                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 500}}>
                                    {t("business_info_2_details1_extra5")}
                                    </Box>
                                </Typography>
                            </Box>

                            <Box sx={{pt: 8}}>
                                <Typography sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize3, fontWeight: 500, textTransform: "uppercase"}}>{t("business_info_3")}</Typography>
                            </Box>
                            <Box sx={{pt: 1, borderTop: 1, borderColor: "#15616D",  display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 500}}>
                                    {t("business_info_3_details1")}
                                    </Box>
                                </Typography>
                            </Box>
                            <Box sx={{display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 500}}>
                                    {t("business_info_3_details2")}
                                    </Box>
                                </Typography>
                            </Box>
                            <Box sx={{pb: 1, borderBottom: 1, borderColor: "#15616D", display:"flex", flexDirection: 'row', alignItems: "center"}}>
                                <CircleIcon sx={{fontSize: "0.5rem", pr: 1}}/>
                                <Typography>
                                    <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize4, fontWeight: 500}}>
                                    {t("business_info_3_details3")}
                                    </Box>
                                </Typography>
                            </Box>
                            <Box sx={{pt: 5}}>
                            <Typography>
                            <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize3, fontWeight: 500, textTransform: "uppercase"}}>
                            {t("business_info_4")}
                            </Box>{' '}
                            <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize3, fontWeight: 400}}>
                            {t("business_info_4_details1")}
                            </Box>
                            </Typography>
                            </Box>

                            <Box sx={{pt: 8}}>
                            <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize3, fontWeight: 500, textTransform: "uppercase"}}>
                            {t("business_info_5")}
                            </Box>
                            <Typography>
                            <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize1, fontWeight: 500}}>
                            {t("business_info_5_details1")}
                            </Box>{' '}
                            <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize1, fontWeight: 400}}>
                            {t("business_info_5_details1_extra1")}
                            </Box>
                            </Typography>
                            <Typography>
                            <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize1, fontWeight: 500}}>
                            {t("business_info_5_details2")}
                            </Box>{' '}
                            <Box display="inline" sx={{fontFamily: "Cormorant Garamond", color: "#15616D", fontSize: fontSize1, fontWeight: 400}}>
                            {t("email")}
                            </Box>
                            </Typography>
                            </Box>
                            
                        </Stack>
            </Box>
          
          <Footer/>
          </Container>
        </Container>
    );
};

export default BusinessPage;